/* Site-wide comfort: header, reveals, buy bar, delivery dates and the gold thread. */
(() => {
  const root = document.documentElement;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch {} }
  };

  /* The header steps aside while reading, and returns on the way back up */
  const head = document.querySelector('.header-section');
  let lastY = scrollY, hidden = false;
  const busy = () => document.body.classList.contains('cart-sidebar-open') || head.matches(':hover, :focus-within') || document.querySelector('.riaz-menu-open[aria-expanded="true"], #search_drawer.active');
  const setHead = (hide) => {
    if (hide === hidden || !head) return;
    hidden = hide;
    head.classList.toggle('ra-head-hidden', hide);
    root.style.setProperty('--ra-head', hide ? '0px' : `${head.offsetHeight}px`);
  };
  const onScroll = () => {
    const y = Math.max(0, scrollY), step = y - lastY;
    if (Math.abs(step) < 6) return;
    lastY = y;
    if (y < 160) setHead(false);
    else if (!busy()) setHead(step > 0);
  };
  if (head) {
    root.style.setProperty('--ra-head', `${head.offsetHeight}px`);
    addEventListener('scroll', onScroll, { passive: true });
  }

  /* Sections rise softly into place the first time they appear */
  if (!calm && 'IntersectionObserver' in window && !document.body.classList.contains('m-home')) {
    const rise = new IntersectionObserver((list) => {
      list.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('ra-in');
        rise.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    document.querySelectorAll('main > .shopify-section').forEach((s, i) => {
      if (i === 0 || s.querySelector('.lr, .bn, .lr-stair, .main_product_main') || s.classList.contains('section-bench')) return;
      s.classList.add('ra-rise');
      rise.observe(s);
    });
  }

  /* Floating buttons step back while the film plays */
  const film = document.querySelector('.bn');
  if (film) {
    new IntersectionObserver(([e]) => root.classList.toggle('ra-film', e.isIntersecting), { rootMargin: '-45% 0px -45% 0px' }).observe(film);
  }

  /* Delivery dates worked out from the shipping policy */
  const RULES = { na: [5, 10], eu: [5, 10], me: [4, 8], row: [7, 14] };
  const EUROPE = 'GB IE FR DE ES IT NL BE AT CH SE NO DK FI PT PL CZ GR HU RO BG HR SK SI EE LV LT LU MT CY IS'.split(' ');
  const GULF = 'AE SA QA KW BH OM JO LB IL'.split(' ');
  const regionOf = (c) => (c === 'US' || c === 'CA' ? 'na' : EUROPE.includes(c) ? 'eu' : GULF.includes(c) ? 'me' : 'row');
  const addWorkingDays = (from, n) => {
    const d = new Date(from);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  };
  const day = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  let detected;
  const detect = () => {
    const saved = store.get('riaz-region');
    if (saved && RULES[saved]) return Promise.resolve(saved);
    detected ||= fetch('/browsing_context_suggestions.json')
      .then((r) => r.json())
      .then((j) => regionOf(j.detected_values?.country?.handle || 'US'))
      .catch(() => 'na');
    return detected;
  };

  class RiazEta extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-eta-region]');
      this.out = this.querySelector('[data-eta-dates]');
      this.select.addEventListener('change', () => {
        store.set('riaz-region', this.select.value);
        this.show();
      });
      detect().then((r) => { this.select.value = r; this.show(); });
    }

    show() {
      const [low, high] = RULES[this.select.value], now = new Date();
      this.out.textContent = `${day(addWorkingDays(now, 1 + low))} to ${day(addWorkingDays(now, 3 + high))}`;
    }
  }
  customElements.get('riaz-eta') || customElements.define('riaz-eta', RiazEta);

  /* The buy bar follows once the main button has scrolled away */
  class RiazBuybar extends HTMLElement {
    connectedCallback() {
      const main = document.querySelector('.product_form_buy_button');
      if (!main) return;
      const add = this.querySelector('[data-rb-add]'), price = this.querySelector('[data-rb-price]');
      this.hidden = false;
      const sync = () => {
        add.disabled = main.disabled;
        add.textContent = main.querySelector('.atc_status')?.textContent.trim() || 'Add to cart';
        const live = document.querySelector('.main_product_price .product_block_price');
        if (live) price.textContent = live.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(document.querySelector('.main_product_info, .main_product_wrapper') || document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      new IntersectionObserver(([e]) => {
        const gone = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.classList.toggle('is-on', gone);
        document.body.classList.toggle('ra-bar-on', gone);
      }).observe(main);
      add.addEventListener('click', () => main.click());
    }
  }
  customElements.get('riaz-buybar') || customElements.define('riaz-buybar', RiazBuybar);

  /* Phone menu buttons reuse the header's own controls */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-rd-open]');
    if (open) document.querySelector(open.dataset.rdOpen)?.click();
  });

  /* A gold thread runs to the cart when something is added */
  let source = null;
  document.addEventListener('pointerdown', (e) => {
    source = e.target.closest('button, a') || source;
  }, true);

  const thread = () => {
    if (calm || !source) return;
    setHead(false);
    const cart = document.querySelector('#cart-icon-bubble'), a = source.getBoundingClientRect();
    if (!cart) return;
    requestAnimationFrame(() => {
      const b = cart.getBoundingClientRect();
      const ax = a.left + a.width / 2, ay = a.top + a.height / 2, bx = b.left + b.width / 2, by = Math.max(b.top + b.height / 2, 24);
      const path = `M${ax} ${ay} C${ax - 120} ${ay - 180}, ${bx - 40} ${by + 200}, ${bx} ${by}`;
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'ra-thread');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = `<path d="${path}"/>`;
      const line = svg.firstChild, dot = document.createElement('i');
      dot.className = 'ra-thread-dot';
      dot.style.offsetPath = `path('${path}')`;
      document.body.append(svg, dot);
      const len = line.getTotalLength();
      line.style.strokeDasharray = `${len}`;
      const time = { duration: 720, easing: 'cubic-bezier(.5,.05,.2,1)', fill: 'forwards' };
      line.animate([{ strokeDashoffset: len }, { strokeDashoffset: 0 }], time);
      dot.animate([{ offsetDistance: '0%' }, { offsetDistance: '100%' }], time).finished.then(() => {
        cart.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 360 });
        line.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 360, fill: 'forwards' }).finished.then(() => { svg.remove(); dot.remove(); });
      }).catch(() => { svg.remove(); dot.remove(); });
    });
  };

  const send = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const result = send.apply(this, arguments);
    if (/\/cart\/add/.test(url)) result.then((r) => { if (r.ok) thread(); }).catch(() => {});
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(() => setTimeout(() => {
        send('/cart.js').then((r) => r.json()).then((c) => {
          document.querySelectorAll('[data-rd-count]').forEach((el) => {
            el.textContent = c.item_count;
            el.hidden = !c.item_count;
          });
        }).catch(() => {});
      }, 250)).catch(() => {});
    }
    return result;
  };

  /* Remember which product photo was tapped, so it can travel to the next page */
  document.addEventListener('click', (e) => {
    const card = e.target.closest('product-card, .hp-product, .lr-option');
    const img = card?.querySelector('img');
    if (img && e.target.closest('a[href*="/products/"]')) window.__raPhoto = img;
  });
  addEventListener('pageswap', (e) => {
    const img = window.__raPhoto;
    if (e.viewTransition && img) {
      img.style.viewTransitionName = 'ra-photo';
      try { sessionStorage.setItem('ra-photo', '1'); } catch {}
    }
  });
})();
